import { composeReducers } from 'complionUtil';
import lodash from 'lodash';

import {
    LOAD_STUDY_TASKS_V2,
    LOAD_STUDY_TASKS_FOR_EXPORT_V2,
    CREATE_STUDY_TASK_V2,
    REMOVE_STUDY_TASK_V2,
    IMPORT_STUDY_TEMPLATE_V2,
    SAVE_STUDY_TASK_V2,
    REMOVE_STUDY_TASKS_V2,
} from 'pages/delegationOfAuthority/v2/actions/studyTasksV2';

const orderedTasks = (tasks) => {
    return lodash.orderBy(tasks, 'taskIndex', 'asc');
};

export function loadStudyTasks(state, action) {
    if (!action || action.type !== LOAD_STUDY_TASKS_V2) {
        return state;
    }

    const doaStudyTasks = action.payload;

    doaStudyTasks.sort(function (a, b) {
        if (a.taskIndex === b.taskIndex) {
            return 0;
        }

        if (a.taskIndex > b.taskIndex) {
            return 1;
        } else {
            return -1;
        }
    });

    return {
        ...state,
        doaStudyTasks,
    };
}

export function loadStudyTasksForExport(state, action) {
    if (!action || action.type !== LOAD_STUDY_TASKS_FOR_EXPORT_V2) {
        return state;
    }

    return {
        ...state,
        doaStudyTasksForExport: action.payload,
    };
}

export function createStudyTask(state, action) {
    if (!action || action.type !== CREATE_STUDY_TASK_V2) {
        return state;
    }

    const addedStudyKeyTask = action.payload;
    if (lodash.isNil(addedStudyKeyTask) || lodash.isEmpty(addedStudyKeyTask)) {
        return state;
    }

    const updatedStudyTasks = lodash.get(state, 'doaStudyTasks', []);
    updatedStudyTasks.push(addedStudyKeyTask);

    return {
        ...state,
        doaStudyTasks: updatedStudyTasks,
    };
}

export function saveStudyTask(state, action) {
    if (!action || action.type !== SAVE_STUDY_TASK_V2) {
        return state;
    }

    const orderedTasks = lodash.orderBy(action.payload.doaStudyTasks, 'taskIndex', 'asc');

    return {
        ...state,
        doaStudyTasks: orderedTasks,
    };
}

export function removeStudyTask(state, action) {
    if (!action || action.type !== REMOVE_STUDY_TASK_V2) {
        return state;
    }

    return {
        ...state,
        doaStudyTasks: orderedTasks(action.payload.doaStudyTasks),
    };
}

export function removeStudyTasks(state, action) {
    if (!action || action.type !== REMOVE_STUDY_TASKS_V2) {
        return state;
    }
    const updateStudyTaskIds = lodash.map(action.payload.doaStudyTasks, (task) => task.id);
    const updatedDelegations = [];
    lodash.each(state.doaStudyDelegations, (delegation) => {
        const currentTaskIds = delegation.taskIds;
        delegation.taskIds = lodash.filter(currentTaskIds, (id) => updateStudyTaskIds.includes(id));
        updatedDelegations.push(delegation);
    });

    return {
        ...state,
        doaStudyTasks: orderedTasks(action.payload.doaStudyTasks),
        doaStudyDelegations: lodash.cloneDeep(updatedDelegations),
    };
}

export function importStudyTemplate(state, action) {
    if (!action || action.type !== IMPORT_STUDY_TEMPLATE_V2) {
        return state;
    }

    const importedStudyTemplateTasks = action.payload;

    return {
        ...state,
        doaStudyTasks: importedStudyTemplateTasks,
    };
}

export default composeReducers(
    loadStudyTasks,
    loadStudyTasksForExport,
    createStudyTask,
    removeStudyTask,
    saveStudyTask,
    importStudyTemplate,
    removeStudyTasks,
);
